import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    NumberInput,
    DateTimeInput,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
} from 'react-admin';

const HomeworkFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索标题" source="key" alwaysOn />
        <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
            <SelectInput optionText="Title" />
        </ReferenceInput>
    </Filter>
);

export const HomeworkList = props => (
    <List {...props} filters={<HomeworkFilter />} title="作业管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="作业标题" />
            <ReferenceField source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <TextField source="Title" />
            </ReferenceField>
            <TextField source="TotalScore" label="满分" />
            <TextField source="SubmitCount" label="提交数" />
            <DateField source="Deadline" label="截止日期" showTime />
            <TextField source="Status" label="状态" />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const HomeworkEdit = props => (
    <Edit {...props} title="编辑作业">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="作业标题" fullWidth />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程">
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="Description" label="作业描述" multiline fullWidth />
            <TextInput source="Attachments" label="附件URL" fullWidth />
            <NumberInput source="TotalScore" label="满分" />
            <DateTimeInput source="Deadline" label="截止日期" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const HomeworkCreate = props => (
    <Create {...props} title="新建作业">
        <SimpleForm>
            <TextInput source="Title" label="作业标题" fullWidth />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程">
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="Description" label="作业描述" multiline fullWidth />
            <TextInput source="Attachments" label="附件URL" fullWidth />
            <NumberInput source="TotalScore" label="满分" defaultValue={100} />
            <DateTimeInput source="Deadline" label="截止日期" />
            <SelectInput source="Status" label="状态" defaultValue={0} choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
            ]} />
        </SimpleForm>
    </Create>
);
